<ng-container *ngIf="offersCategories$ | async as offerCategories">
  <div class="affiliate-categories-block">
    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let category of offerCategories">
        <ng-template carouselSlide [width]="category.Name | categoryWidth">
          <div
            [ngStyle]="{ width: category.Name | categoryWidth }"
            class="category shadow-sm text-center me-2"
            [ngClass]="{ 'btn-selected': categoryTagId == category.TagId, 'btn-not-selected': categoryTagId != category.TagId }"
            (click)="categoryEmitter(category)"
          >
            <p class="category-name m-0">{{ category.Name }}</p>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</ng-container>
